export const getTextLength = (str) => {
  let len = 0
  for (var i = 0; i < str.length; i++) {
    // console.log(str.codePointAt(i))
    if (str.codePointAt(i) > 9999) {
      len++
    }
    len++
  }
  return len
}

export const cutTextLimit = (str, limit) => {
  let len = 0
  let newStr = ""
  for (var i = 0; i < str.length; i++) {
    newStr += str[i]
    if (str.codePointAt(i) > 9999) {
      len++
    }
    len++
    if (len > limit) break
  } 
  return newStr
}